export enum PartnerStatus {
  ACTIVE = 'active',
  REJECTED = 'rejected',
  PENDING = 'pending',
  SUSPENDED = 'suspended',
  CLOSED = 'closed',
}
